import React, { Fragment, useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
  FormFeedback,
} from 'reactstrap';
import { useFormik } from 'formik';
import {
  CREATE_COUPONS_URL,
  UPDATE_COUPONS_URL,
} from '../../../utils/APIEndpoints';
import { AGENCY_COUPONS_PAGE } from '../../../utils/AppRoutes';
import {
  getCurrentUserId,
  getCurrentAgencyId,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import CustomLoader from '../../common/CustomLoader';
import { useHistory, useParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { getCouponDetails } from '../../../redux/actions/index';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';

function NewCoupons(props) {
  const { id = 0 } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  let location = useLocation();
  const [loading, setLoading] = useState(false);
  const [editFlow, setEditFlow] = useState('');
  let [initialValues, setInitialValues] = useState({
    couponCode: '',
    userCount: '',
    discountPercentage: '',
  });

  const { detail = {}, error = false } = useSelector(
    (state) => state.CouponDetailReducer
  );

  const validationSchema = Yup.object({
    couponCode: Yup.string().trim().required('CouponCode is required'),
    userCount: Yup.number()
      .required('User Count is Required')
      .test(
        'Is positive?',
        'The number must be greater than 0',
        (value) => value > 0
      ),
    discountPercentage: Yup.number()
      .required('Discount Percentage is Required')
      .test(
        'Is positive?',
        'The number must be greater than 0',
        (value) => value > 0
      ),
  });

  const { handleSubmit, handleChange, values, errors, touched, resetForm } =
    useFormik({
      initialValues,
      validationSchema,
      enableReinitialize: true,
      onSubmit: (values) => {
        // console.log('Values', values);
        createCoupons(values);
      },
    });

  const back = () => {
    history.push(AGENCY_COUPONS_PAGE);
  };

  //create Customer
  const createCoupons = async (values) => {
    values.createdBy = getCurrentUserId();
    values.agencyId = getCurrentAgencyId();
    try {
      setLoading(true);
      const options = {
        method: editFlow == 'edit' ? 'PUT' : 'POST',
        url: editFlow == 'edit' ? UPDATE_COUPONS_URL : CREATE_COUPONS_URL,
        headers: authHeader(),
        data:
          editFlow == 'edit'
            ? {
                couponId: parseInt(id),
                couponCode: values.couponCode,
                userCount: values.userCount,
                discountPercentage: values.discountPercentage,
                agencyId: getCurrentAgencyId(),
              }
            : values,
      };
      const response = await API(options);
      // console.log('Response ', response);
      const { status, message } = response.data;
      if (status === 'Success') {
        Swal.fire(getAlertToast('success', message));
        history.push(AGENCY_COUPONS_PAGE);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getCouponDetails(id));
    }
  }, []);

  useEffect(() => {
    if (Object.entries(detail).length !== 0 && detail.constructor === Object) {
      if (error) {
        Swal.fire(getAlertToast('error', detail));
      } else {
        setInitialValues({
          couponCode: detail.couponCode,
          userCount: detail.userCount,
          discountPercentage: detail.discountPercentage,
        });
      }
    }
  }, [detail]);

  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[2] || '/';
    setEditFlow(currentMenuToActive);
  }, [location]);

  return (
    <Fragment>
      <Container fluid className="mt-5">
        <Card body>
          <CardTitle tag="h6" className="item-center">
            New Coupons
            <div className="invoice-BTn-l">
              <Button color="primary" onClick={back}>
                <i className="fas fa-arrow-left" />
                Back
              </Button>
            </div>
          </CardTitle>

          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="couponCode">Coupon Code</Label>
              <Input
                type="text"
                name="couponCode"
                id="couponCode"
                onChange={handleChange}
                value={values.couponCode}
                invalid={errors.couponCode && touched.couponCode ? true : false}
                placeholder="Enter Coupon Code"
              />
              <FormFeedback>
                {errors.couponCode && touched.couponCode
                  ? errors.couponCode
                  : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="userCount">User Count</Label>
              <Input
                type="number"
                name="userCount"
                id="userCount"
                placeholder="Enter User Count"
                onChange={handleChange}
                invalid={errors.userCount && touched.userCount ? true : false}
                value={values.userCount}
                min={1}
              />
              <FormFeedback>
                {errors.userCount && touched.userCount ? errors.userCount : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="discountPercentage">Discount Percentage</Label>
              <Input
                type="number"
                name="discountPercentage"
                id="discountPercentage"
                onChange={handleChange}
                value={values.discountPercentage}
                invalid={
                  errors.discountPercentage && touched.discountPercentage
                    ? true
                    : false
                }
                placeholder="Enter Discount Percentage"
                min={0.1}
                step="any"
              />
              <FormFeedback>
                {errors.discountPercentage && touched.discountPercentage
                  ? errors.discountPercentage
                  : ''}
              </FormFeedback>
            </FormGroup>

            <Button type="submit">
              <CustomLoader loading={loading} />
              {editFlow == 'edit' ? 'Save' : 'Submit'}
            </Button>
          </Form>
        </Card>
      </Container>
    </Fragment>
  );
}

export default NewCoupons;
